import * as at from "../action-types";
import { types, apiActionCreator } from "@authzsvc/api-lib";

export const setBreadcrumbs = (nav) => (dispatch) => {
  dispatch({
    type: at.SET_BREADCRUMBS,
    payload: { nav: nav },
  });
};

export const dismissError = () => {
  return async (dispatch) => {
    dispatch({ type: at.CLEAR_ERROR });
  };
};

export const addError = (error) => {
  return async (dispatch) => {
    dispatch({ type: at.ADD_ERROR, error });
  };
};

export const clearRegistrationDetails = () => {
  return async (dispatch) => {
    dispatch({ type: at.CLEAR_REGISTRATION_DETAILS });
  };
};

export const clearSecretDetails = () => {
  return async (dispatch) => {
    dispatch({ type: at.CLEAR_SECRET_DETAILS });
  };
};

// API calls
export const getApplicationList = (queryFilter) => {
  return async (dispatch) => {
    dispatch(apiActionCreator(types.GET_APPLICATION_LIST, { queryFilter }));
  };
};

export const getApplicationListMultipleFields =
  (queryFilter) => async (dispatch) => {
    return await dispatch(
      apiActionCreator(types.GET_APPLICATION_LIST, { queryFilter }),
    );
  };

export const getAllApplications = (queryFilter) => async (dispatch) => {
  return await dispatch(
    apiActionCreator(types.GET_ALL_APPLICATIONS, { queryFilter }),
  );
};

export const deleteApplication = (application) => (dispatch) => {
  dispatch(
    apiActionCreator(types.DELETE_APPLICATION, {
      applicationid: application.id,
    }),
  );
};

export const addRole = (role) => (dispatch) => {
  dispatch(apiActionCreator(types.ADD_ROLE, { role: role }));
};

export const deleteRole = (role) => (dispatch) => {
  dispatch(
    apiActionCreator(types.DELETE_ROLE, {
      applicationid: role.applicationId,
      roleid: role.id,
    }),
  );
};

export const updateRole = (role) => async (dispatch) =>
  await dispatch(
    apiActionCreator(types.UPDATE_ROLE, {
      applicationid: role.applicationId,
      roleid: role.id,
      role: role,
    }),
  );

export const addApplication = (application) => async (dispatch) => {
  return await dispatch(
    apiActionCreator(types.ADD_APPLICATION, { application }),
  );
};

export const editApplication = (application) => async (dispatch) =>
  await dispatch(apiActionCreator(types.EDIT_APPLICATION, { application }));

export const getApplication = (applicationid) => async (dispatch) =>
  await dispatch(
    apiActionCreator(types.GET_APPLICATION, { applicationid: applicationid }),
  );

export const getRoleForApplication = (applicationid, roleid) => (dispatch) => {
  dispatch(
    apiActionCreator(types.GET_ROLE_FOR_APPLICATION, {
      applicationid: applicationid,
      roleid: roleid,
    }),
  );
};

export const getRolesForApplication = (applicationid) => async (dispatch) =>
  await dispatch(
    apiActionCreator(types.GET_ROLES, { applicationid: applicationid }),
  );

export const getGroupsForApplication = (application) => async (dispatch) =>
  await dispatch(
    apiActionCreator(types.GET_IDENTITY_MEMBERSHIPS, {
      identityId: application.identityId,
    }),
  );

/*
  The API does not return full information about the group so it's easier to
  just get all the groups again.
*/
export const addGroupToRole = (applicationid, roleid, groupid) => (dispatch) =>
  dispatch(
    apiActionCreator(types.ADD_GROUP_TO_ROLE, {
      applicationid: applicationid,
      roleid: roleid,
      groupid: groupid,
    }),
  ).then((addResponse) => {
    dispatch(
      apiActionCreator(types.GET_GROUPS_FOR_ROLE, {
        applicationid: applicationid,
        roleid: roleid,
      }),
    );

    return addResponse;
  });

export const addIdentityMembershipsToGroup =
  (groupId, identityIds) => async (dispatch) =>
    await dispatch(
      apiActionCreator(types.ADD_GROUP_MEMBER_IDENTITIES, {
        groupId,
        identityIds,
      }),
    );

export const deleteIdentityMembershipFromGroup =
  (groupId, application) => async (dispatch) =>
    await dispatch(
      apiActionCreator(types.DELETE_IDENTITY_MEMBERSHIP_FROM_GROUP, {
        groupId: groupId,
        identityId: application.identityId,
      }),
    ).then((deleteResponse) => {
      dispatch(
        apiActionCreator(types.GET_IDENTITY_MEMBERSHIPS, {
          identityId: application.identityId,
        }),
      );
      return deleteResponse;
    });

export const deleteGroupFromRole =
  (applicationid, roleid, groupid) => (dispatch) =>
    dispatch(
      apiActionCreator(types.DELETE_GROUP_FROM_ROLE, {
        applicationid: applicationid,
        roleid: roleid,
        groupid: groupid,
      }),
    ).then((deleteResponse) => {
      dispatch(
        apiActionCreator(types.GET_GROUPS_FOR_ROLE, {
          applicationid: applicationid,
          roleid: roleid,
        }),
      );

      return deleteResponse;
    });

export const getGroupsForRole = (applicationid, roleid) => (dispatch) => {
  dispatch(
    apiActionCreator(types.GET_GROUPS_FOR_ROLE, {
      applicationid: applicationid,
      roleid: roleid,
    }),
  );
};

export const getAllApplicationsV2 = (queryFilter) => async (dispatch) => {
  return await dispatch(
    apiActionCreator(types.GET_ALL_APPLICATIONS_V2, { queryFilter }),
  );
};

export const getApplicationListMultipleFieldsV2 =
  (queryFilter) => async (dispatch) => {
    return await dispatch(
      apiActionCreator(types.GET_APPLICATION_LIST_V2, { queryFilter }),
    );
  };

export const getAllGroups = () => (dispatch) => {
  dispatch(apiActionCreator(types.GET_MY_GROUPS));
};

export const getRegistrationProviders = () => (dispatch) => {
  dispatch(apiActionCreator(types.GET_PROVIDERS));
};

export const selectRegistrationForEdit = (registration) => (dispatch) => {
  dispatch({ type: at.SELECT_REGISTRATION, data: registration });
};
export const resetSelectedRegistration = () => (dispatch) => {
  dispatch({ type: at.CLEAR_SELECTED_REGISTRATION });
};

export const updateRegistration = (providerid, details) => async (dispatch) => {
  return await dispatch(
    apiActionCreator(types.UPDATE_REGISTRATION, {
      providerid: providerid,
      details: details,
    }),
  );
};

export const getRegistrationsForApplication = (applicationid) => (dispatch) => {
  dispatch(
    apiActionCreator(types.GET_REGISTRATIONS, { applicationid: applicationid }),
  );
};

export const registerApplication =
  (applicationid, providerid, details) => async (dispatch) => {
    return await dispatch(
      apiActionCreator(types.REGISTER_APPLICATION, {
        applicationid: applicationid,
        providerid: providerid,
        details: details,
      }),
    );
  };

export const resolveIdentity = (identityid) => async (dispatch) => {
  return await dispatch(
    apiActionCreator(types.RESOLVE_IDENTITY, { identityid: identityid }),
  );
};

export const resolveApplicationManager = (identityid) => async (dispatch) =>
  await dispatch(
    apiActionCreator(types.RESOLVE_APPLICATION_MANAGER_IDENTITY, {
      identityid,
    }),
  );

export const deleteRegistration = (registrationid) => (dispatch) => {
  dispatch(
    apiActionCreator(types.DELETE_REGISTRATION, {
      registrationid: registrationid,
    }),
  );
};

export const regenerateSecret = (registrationid, providerid) => (dispatch) => {
  dispatch(
    apiActionCreator(types.REGENERATE_SECRET, {
      registrationid: registrationid,
      providerid: providerid,
    }),
  );
};

export const displaySecret = (registrationid) => async (dispatch) =>
  await dispatch(
    apiActionCreator(types.DISPLAY_SECRET, {
      registrationid: registrationid,
    }),
  );

export const searchForGroup =
  (queryFilter, limit = 30) =>
  async (dispatch) =>
    await dispatch(
      apiActionCreator(types.SEARCH_GROUP, { queryFilter, limit }),
    );

export const getGroupById = (id) => async (dispatch) =>
  await dispatch(apiActionCreator(types.GET_GROUP_BY_ID, { id: id }));

export const logout = () => async (dispatch) =>
  await dispatch(apiActionCreator(types.LOGOUT));

export const getAllowedTokenExchangePermissions =
  (registrationId, queryFilter) => async (dispatch) =>
    await dispatch(
      apiActionCreator(types.GET_ALLOWED_TOKEN_EXCHANGE_PERMISSIONS, {
        queryFilter,
        registrationId,
      }),
    );

export const getGrantedTokenExchangePermissions =
  (registrationId, queryFilter) => async (dispatch) =>
    await dispatch(
      apiActionCreator(types.GET_GRANTED_TOKEN_EXCHANGE_PERMISSIONS, {
        queryFilter,
        registrationId,
      }),
    );

export const searchForRegistration =
  (authenticationProviderId, queryFilter) => async (dispatch) =>
    await dispatch(
      apiActionCreator(types.SEARCH_REGISTRATIONS, {
        authenticationProviderId,
        queryFilter,
      }),
    );

export const createTokenExchangeRequest = (body) => async (dispatch) =>
  await dispatch(
    apiActionCreator(types.PUT_TOKEN_EXCHANGE_REQUEST_WITH_BODY_PARAMS, body),
  );

export const deleteTokenExchangePermission =
  (target, source) => async (dispatch) =>
    await dispatch(
      apiActionCreator(types.DELETE_TOKEN_EXCHANGE_PERMISSION, {
        target,
        source,
      }),
    );

// Requests
export const getMyRequests = () => (dispatch) => {
  dispatch(
    apiActionCreator(types.GET_REQUESTS, {
      queryFilter: {},
    }),
  );
};

export const searchForPerson = (name) => async (dispatch) => {
  return await dispatch(apiActionCreator(types.SEARCH_IDENTITY, { name }));
};

export const transferApplicationOwner =
  (applicationId, identityId) => async (dispatch) => {
    return await dispatch(
      apiActionCreator(types.TRANSFER_APPLICATION_OWNER, {
        applicationId,
        identityId,
      }),
    );
  };

export const getRequestsToApprove = () => (dispatch) => {
  dispatch(
    apiActionCreator(types.GET_REQUESTS_TO_APPROVE, {
      queryFilter: {},
    }),
  );
};

export const cancelRequest = (id) => async (dispatch) => {
  return await dispatch(apiActionCreator(types.CANCEL_REQUEST, { id: id }));
};

export const denyRequest = (id, reason) => async (dispatch) => {
  return await dispatch(
    apiActionCreator(types.DENY_REQUEST, {
      id: id,
      reason: reason,
    }),
  );
};

export const approveRequest = (id, reason) => async (dispatch) => {
  return await dispatch(
    apiActionCreator(types.APPROVE_REQUEST, {
      id: id,
      reason: reason,
    }),
  );
};

export const getLevelsOfAssurance = () => (dispatch) => {
  dispatch(apiActionCreator(types.GET_LEVELS_OF_ASSURANCE));
};

export const toggleSidebar = () => (dispatch) => {
  dispatch({
    type: at.TOGGLE_SIDEBAR,
  });
};

export const closeApprovalRequiredModal = () => (dispatch) => {
  dispatch({
    type: at.CLOSE_APPROVAL_REQUIRED_MODAL,
  });
};
